import { useParams } from "react-router-dom";

export const useDealer = () => {
  const { dealer_id } = useParams();
  return {
    dealer_id,
  };
};
